<div class="d-grid d-md-flex gap-3 mb-0 mb-md-4">
  <div
    class="d-flex d-md-grid justify-content-between align-items-center travellers-select-container"
  >
    <label class="label-age fs-12 fw-medium d-grid label-counter"
      >Adults
      <span class="fs-10 fw-normal">12 Years & Above</span>
    </label>
    <div class="traveller-input-group increase d-flex align-items-center">
      <div
        class="btn btn-outline-secondary decrease"
        (click)="decreaseAdults()"
      >
        -
      </div>
      <div class="traveller-count">{{ adultsCount }}</div>
      <div class="btn btn-outline-secondary fs-12" (click)="increaseAdults()">
        +
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div
    class="d-flex d-md-grid justify-content-between align-items-center travellers-select-container"
  >
    <label class="label-age fs-12 fw-medium d-grid label-counter"
      >Children
      <span class="fs-10 fw-normal">2-12 yrs</span>
    </label>
    <div class="traveller-input-group increase d-flex align-items-center">
      <div
        class="btn btn-outline-secondary decrease"
        (click)="decreaseChildren()"
      >
        -
      </div>
      <div class="traveller-count">{{ childrenCount }}</div>
      <div class="btn btn-outline-secondary fs-12" (click)="increaseChildren()">
        +
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div
    class="d-flex d-md-grid justify-content-between align-items-center travellers-select-container"
  >
    <label class="label-age fs-12 fw-medium d-grid label-counter"
      >Infant <span class="fs-10 fw-normal">0-2 yrs</span></label
    >
    <div class="traveller-input-group increase d-flex align-items-center">
      <div
        class="btn btn-outline-secondary decrease"
        (click)="decreaseInfants()"
      >
        -
      </div>
      <div class="traveller-count">{{ infantsCount }}</div>
      <div class="btn btn-outline-secondary fs-12" (click)="increaseInfants()">
        +
      </div>
    </div>
  </div>
</div>

<div class="w-100 d-flex justify-content-center apply-button-container">
  <app-button
    type="primary"
    class="slim fs-14"
    [disabled]="!isTravellerApplyEnabled"
    [title]="isTravellerApplyEnabled ? '' : 'Add a adult traveller to proceed'"
    (click)="applyTravellerChanges()"
    >Apply</app-button
  >
</div>
